export const iconList = [
  'pi pi-chart-line',
  'pi pi-chart-bar',
  'pi pi-chart-pie',
  'pi pi-chart-scatter',
];

export const getRandomItem = arr => arr[Math.floor(Math.random() * arr.length)];
